export const NESS_LABS_BADGE = {
  ea: 'Early Access', // NessLabsConstantS.PRODUCT_EA_LIST 에 있는 상품들의 뱃지
  release: 'Official Release',
  special: 'Special Offer',
};
